(function () {
  "use strict";

  function getVariantData(card) {
    const json = card.querySelector(".elvn-variants-json");
    if (!json) return null;
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
  }

  function getActiveColor(card) {
    const checked = card.querySelector(".elvn-card-swatches .opt-btn:checked");
    if (checked) return checked.value;
    return null;
  }

  function buildChips(variants) {
    if (!variants.length) return "";
    return variants
      .map((v) => {
        const oos = !v.available ? " is-oos" : "";
        return `<button 
          class="elvn-size-chip${oos}" 
          type="button"
          data-variant-id="${v.id}"
          data-size="${v.size}"
          ${!v.available ? 'aria-disabled="true"' : ""}
        >${v.size}</button>`;
      })
      .join("");
  }

  function bumpCartCount(by) {
    try {
      let badge = document.querySelector(".header__cart-count");

      if (!badge) {
        const cartIcon = document.querySelector("#cart-icon");
        if (!cartIcon) return;
        badge = document.createElement("div");
        badge.className = "header__cart-count count-badge absolute text-center";
        cartIcon.appendChild(badge);
      }

      const visibleSpan = badge.querySelector("span[aria-hidden]");
      const hiddenSpan = badge.querySelector(".visually-hidden");
      const current = parseInt(visibleSpan?.textContent || "0", 10);
      const next = current + by;

      if (next < 100) {
        if (visibleSpan) {
          visibleSpan.textContent = next;
        } else {
          badge.insertAdjacentHTML(
            "afterbegin",
            `<span aria-hidden="true">${next}</span>`,
          );
        }
      } else {
        if (visibleSpan) visibleSpan.remove();
      }

      if (hiddenSpan) hiddenSpan.textContent = `${next} items in cart`;

      badge.classList.add("elvn-count-bump");
      setTimeout(() => badge.classList.remove("elvn-count-bump"), 400);
    } catch (e) {}
  }

  class ElvnQuickAdd {
    constructor(card) {
      if (card.classList.contains("elvn-initialized")) return;
      card.classList.add("elvn-initialized");

      this.card = card;
      this.strip = card.querySelector(".elvn-size-strip");
      this.chipsContainer = card.querySelector(".elvn-size-strip__chips");
      this.addBtn = card.querySelector(".elvn-size-strip__add");

      if (!this.strip || !this.chipsContainer || !this.addBtn) return;

      this.variantData = getVariantData(card);
      if (!this.variantData) return;

      this.selectedVariantId = null;
      this.isAdding = false;
      this.activeColor = getActiveColor(card);

      this.bindEvents();
      this.renderChips();
    }

    bindEvents() {
      this.chipsContainer.addEventListener("click", (e) => {
        const chip = e.target.closest(".elvn-size-chip");
        if (!chip || chip.classList.contains("is-oos")) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.selectChip(chip);
      });

      this.addBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleAdd();
      });

      this.card.addEventListener("change", (e) => {
        if (e.target.matches(".opt-btn")) {
          setTimeout(() => {
            this.selectedVariantId = null;
            this.renderChips();
            this.resetAddBtn();
            this.clearMsg();
          }, 50);
        }
      });

      this.card.addEventListener("click", (e) => {
        const swatch = e.target.closest(".elvn-card-swatches .opt-btn");
        if (!swatch) return;

        this.card
          .querySelectorAll(".elvn-card-swatches .opt-btn")
          .forEach((input) => (input.checked = false));
        swatch.checked = true;

        this.activeColor = swatch.value; // <-- store directly, no DOM re-read later

        this.selectedVariantId = null;
        this.renderChips();
        this.resetAddBtn();
        this.clearMsg();
      }, true);


      this.card.addEventListener("mouseleave", () => {
        setTimeout(() => {
          if (!this.card.classList.contains("is-open")) {
            this.selectedVariantId = null;
            this.renderChips();
            this.resetAddBtn();
            this.clearMsg();
          }
        }, 350); 
      });

      const media = this.card.querySelector(".card__media");
      if (media && window.matchMedia("(hover: none)").matches) {
        media.addEventListener("click", (e) => {
          if (e.target.closest(".elvn-size-strip")) return;
          if (e.target.closest("a")) return;

          e.preventDefault();
          this.card.classList.toggle("elvn-touch-open");
        });

        document.addEventListener("click", (e) => {
          if (!this.card.contains(e.target)) {
            this.card.classList.remove("elvn-touch-open");
            this.selectedVariantId = null;
            this.renderChips();
            this.resetAddBtn();
          }
        });
      }
    }

    normalize(str) {
      return str?.toLowerCase().replace(/\s+/g, "").trim();
    }

    renderChips() {
      const { variants, hasColorOption } = this.variantData;
      const activeColor = this.activeColor;

      let filtered;
      if (hasColorOption && activeColor) {
        filtered = variants.filter(
          (v) => this.normalize(v.color) === this.normalize(activeColor),
        );

        if (!filtered.length) {
          console.warn("No variants found for color:", activeColor);
        }
      } else {
        filtered = variants;
      }

      const seen = new Set();
      const unique = filtered.filter((v) => {
        if (seen.has(v.size)) return false;
        seen.add(v.size);
        return true;
      });

      this.chipsContainer.innerHTML = buildChips(unique);

      if (this.selectedVariantId) {
        const stillValid = unique.find(
          (v) => v.id === this.selectedVariantId && v.available,
        );
        if (stillValid) {
          const chip = this.chipsContainer.querySelector(
            `[data-variant-id="${this.selectedVariantId}"]`,
          );
          if (chip) chip.classList.add("is-selected");
        } else {
          this.selectedVariantId = null;
        }

      }
    }

    selectChip(chip) {
      this.chipsContainer.querySelectorAll(".elvn-size-chip").forEach((c) => {
        c.classList.remove("is-selected");
      });

      chip.classList.add("is-selected");
      this.selectedVariantId = parseInt(chip.dataset.variantId, 10);
      this.clearMsg();

    }

    // async handleAdd() {
    //   if (this.isAdding) return;

    //   if (!this.selectedVariantId) {
    //     this.showMsg("Please select a size");
    //     this.addBtn.classList.add("is-error");
    //     setTimeout(() => this.addBtn.classList.remove("is-error"), 1000);
    //     return;
    //   }

    //   this.isAdding = true;
    //   this.addBtn.disabled = true;
    //   this.addBtn.textContent = "...";
    //   this.clearMsg();

    //   try {
    //     const res = await fetch("/cart/add.js", {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         "X-Requested-With": "XMLHttpRequest",
    //       },
    //       body: JSON.stringify({ id: this.selectedVariantId, quantity: 1 }),
    //     });

    //     if (!res.ok) {
    //       const err = await res.json();
    //       throw new Error(err.description || "Could not add to cart");
    //     }

    //     // Success
    //     this.addBtn.textContent = "Added ✓";
    //     this.addBtn.classList.add("is-added");
    //     await updateCartCount();

    //     // Check if theme setting opens cart drawer after ATC
    //     if (window.theme?.settings?.afterAtc === "drawer") {
    //       const cartDrawer = document.querySelector("cart-drawer");
    //       if (cartDrawer) {
    //         setTimeout(() => cartDrawer.open(), 300);
    //       }
    //     }

    //     // Reset after 2s
    //     setTimeout(() => {
    //       this.addBtn.classList.remove("is-added");
    //       this.resetAddBtn();
    //       // Don't reset chip selection — user may want to add again
    //     }, 2000);
    //   } catch (err) {
    //     this.addBtn.textContent = "Error";
    //     this.addBtn.classList.add("is-error");
    //     this.showMsg(err.message || "Something went wrong");

    //     setTimeout(() => {
    //       this.addBtn.classList.remove("is-error");
    //       this.resetAddBtn();
    //     }, 2000);
    //   } finally {
    //     this.isAdding = false;
    //     this.addBtn.disabled = false;
    //   }
    // }

    getSelectedVariant() {
      const activeColor = this.activeColor;

      const selectedChip = this.card.querySelector(
        ".elvn-size-chip.is-selected",
      );
      if (!selectedChip) return null;

      const selectedSize = selectedChip.dataset.size;

      const { variants } = this.variantData;

      const variant = variants.find((v) => {
        const sizeMatch =
          this.normalize(v.size) === this.normalize(selectedSize);
        if (!activeColor) return sizeMatch;
        return (
          this.normalize(v.color) === this.normalize(activeColor) && sizeMatch
        );
      });

      return variant || null;
    }

    async handleAdd() {
      if (this.isAdding) return;

      const variant = this.getSelectedVariant();

      if (!variant) {
        this.showMsg("Please select size");
        this.addBtn.classList.add("is-error");
        setTimeout(() => this.addBtn.classList.remove("is-error"), 1000);
        return;
      }

      // console.log("ADDING VARIANT:", variant);

      this.isAdding = true;
      this.addBtn.disabled = true;
      this.addBtn.textContent = "Adding...";
      this.clearMsg();

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
          }),
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || "Could not add to cart");
        }

        this.addBtn.textContent = "Added ✓";
        this.addBtn.classList.add("is-added");

        bumpCartCount(1);

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          const drawerRes = await fetch("/?section_id=cart-drawer");
          const html = await drawerRes.text();
          const temp = document.createElement("div");
          temp.innerHTML = html;
          const newDrawer = temp.querySelector("cart-drawer");
          if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.open();
        }

        setTimeout(() => {
          this.addBtn.classList.remove("is-added");
          this.resetAddBtn();
        }, 2000);
      } catch (err) {
        this.addBtn.textContent = "Error";
        this.addBtn.classList.add("is-error");
        this.showMsg(err.message || "Something went wrong");

        setTimeout(() => {
          this.addBtn.classList.remove("is-error");
          this.resetAddBtn();
        }, 2000);
      } finally {
        this.isAdding = false;
        this.addBtn.disabled = false;
      }
    }

    resetAddBtn() {
      this.addBtn.textContent = "Quick Add";
      this.addBtn.disabled = false;
      this.addBtn.classList.remove("is-added", "is-error");
    }

    showMsg(text) {
      this.clearMsg();
      const msg = document.createElement("span");
      msg.className = "elvn-size-strip__msg";
      msg.textContent = text;
      this.strip.appendChild(msg);
    }

    clearMsg() {
      this.strip.querySelector(".elvn-size-strip__msg")?.remove();
    }
  }

  window.elvnBumpCartCount = bumpCartCount;

  function initCards() {
    document.querySelectorAll("product-card").forEach((card) => {
      if (!card.dataset.elvnQaInit) {
        card.dataset.elvnQaInit = "1";
        new ElvnQuickAdd(card);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCards);
  } else {
    initCards();
  }

  const observer = new MutationObserver((mutations) => {
    let foundNewCards = false;

    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === "PRODUCT-CARD") {
            if (!node.dataset.elvnQaInit) {
              node.dataset.elvnQaInit = "1";
              new ElvnQuickAdd(node);
              foundNewCards = true;
            }
          }
          if (node.querySelectorAll) {
            node
              .querySelectorAll("product-card:not([data-elvn-qa-init])")
              .forEach((card) => {
                card.dataset.elvnQaInit = "1";
                new ElvnQuickAdd(card);
                foundNewCards = true;
              });
          }
        });
      }
    }

    if (foundNewCards) initMobileCardReveal();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

let elvnOutsideClickBound = false;

function initMobileCardReveal() {
  const cards = document.querySelectorAll("product-card");

  cards.forEach((card) => {
    if (card.classList.contains("elvn-touch-init")) return;
    card.classList.add("elvn-touch-init");

    card.addEventListener("click", (e) => {
      if (e.target.closest("button, a, input, label, .quick-cart-icon")) return;

      const isOpen = card.classList.contains("elvn-hover");

      document.querySelectorAll("product-card.elvn-hover").forEach((c) => {
        c.classList.remove("elvn-hover");
      });

      if (!isOpen) {
        card.classList.add("elvn-hover");
      }
    });

    const quickIcon = card.querySelector(".quick-cart-icon");

    if (quickIcon) {
      quickIcon.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = card.classList.contains("elvn-hover");

        document.querySelectorAll("product-card.elvn-hover").forEach((c) => {
          c.classList.remove("elvn-hover");
        });

        if (!isOpen) {
          card.classList.add("elvn-hover");
        }
      });
    }
  });

  if (!elvnOutsideClickBound) {
    elvnOutsideClickBound = true;

    document.addEventListener("click", (e) => {
      if (!e.target.closest("product-card")) {
        document
          .querySelectorAll("product-card.elvn-hover")
          .forEach((c) => c.classList.remove("elvn-hover"));
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", initMobileCardReveal);
document.addEventListener("shopify:section:load", initMobileCardReveal);
